import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = ({ onBack }) => {
  return (
    <motion.div 
      className="legal-page"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="legal-header">
        <motion.button
          className="back-button-legal"
          onClick={onBack}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <ArrowLeft size={20} />
          Back
        </motion.button>
        <h1>Terms of Service</h1>
      </div>
      
      <div className="legal-content">
        <p className="effective-date"><strong>Effective Date:</strong> July 18, 2025</p>
        
        <p>These Terms of Service ("Terms") govern your use of the BrainRotAI Minecraft video generation service ("Service"). By accessing or using the Service, you agree to be bound by these Terms.</p>
        
        <h2>1. User Accounts</h2>
        <p>You must create an account to use the Service. You are responsible for maintaining the confidentiality of your account credentials. You agree not to share your account with others.</p>
        
        <h2>2. Acceptable Use</h2>
        <p>You agree to use the Service only for lawful purposes. You may not use the Service to generate content that is illegal, harmful, threatening, abusive, harassing, defamatory, vulgar, obscene, libelous, invasive of another's privacy, hateful, or racially, ethnically, or otherwise objectionable. Excessive use of the service, such as generating a large number of videos simultaneously, is prohibited.</p>
        
        <h2>3. Intellectual Property</h2>
        <p>You retain ownership of any scripts or topics you provide. BrainRotAI owns the copyright to the software and underlying technology of the Service. You are granted a non-exclusive license to use the videos generated by the Service for your personal use. You may not redistribute or resell the generated videos without our express written consent.</p>
        
        <h2>4. Payment Terms</h2>
        <p>If you subscribe to a paid plan, you agree to pay the applicable fees. Payment processing is handled by Stripe. Their terms and conditions apply to all transactions. Refunds are issued only if you cancel your subscription before the end of the current billing cycle.</p>
        
        <h2>5. Account Termination</h2>
        <p>We may terminate your account at any time for any reason, including but not limited to violation of these Terms or misuse of the Service.</p>
        
        <h2>6. Disclaimer of Warranties</h2>
        <p>The Service is provided "as is" without any warranties, express or implied.</p>
        
        <h2>7. Limitation of Liability</h2>
        <p>Our liability for any damages arising from your use of the Service is limited to the extent permitted by law.</p>
        
        <h2>8. Governing Law</h2>
        <p>These Terms are governed by the laws of the United States.</p>
        
        <h2>9. Changes to These Terms</h2>
        <p>We may update these Terms from time to time. We will post any changes on this page.</p>
        
        <h2>10. Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us at support@brainrotai.com.</p>
      </div>
    </motion.div>
  );
};

export default TermsOfService;
